import { QUILL_SIGNATURE_MS } from '../primitives';
import { SPLASH_ID } from './bootWatchdog';

// The startup loader's timeline. The static splash in index.html starts the
// quill while the JavaScript downloads; StartupGate continues that timeline
// (so the quill never jumps back to the start at the hand-off) and keeps the
// loader up until its first stroke is complete, however soon the app is ready.

/**
 * When the loader's timeline began, on the `performance.now()` clock: the
 * static splash's when it is still on screen, otherwise `now`. Without Web
 * Animations the splash is taken to have started with the navigation.
 */
export function loaderEpoch(doc: Document = document, now = performance.now()): number {
  const splash = doc.getElementById(SPLASH_ID);
  if (!splash) return now;
  if (typeof splash.getAnimations !== 'function') return 0;
  // Every animation in the splash starts when it is first styled; any one dates it.
  const started = splash.getAnimations({ subtree: true }).find((animation) => animation.currentTime !== null);
  return started ? now - Number(started.currentTime) : now;
}

/** How much longer the loader must stay for its first stroke to complete. */
export function signatureRemaining(epoch: number, now = performance.now()): number {
  return Math.max(0, epoch + QUILL_SIGNATURE_MS - now);
}

/**
 * Whether startup waits for the first stroke and fades out. Not with reduced
 * motion (the line is drawn at once) nor in automated browsers, so end-to-end
 * runs don't wait three seconds on every page load.
 */
export function holdsForSignature(win: Window = window): boolean {
  if (win.navigator.webdriver) return false;
  return !win.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
